"use client";

import { WorkerPayloadTypes } from "@/constants";
import type { StatsData } from "@/types";
import { useEffect, useState, type FC } from "react";
import styles from "./styles.module.css";

interface WorkerStatsProps {
  worker?: Worker;
}

export const WorkerStats: FC<WorkerStatsProps> = ({ worker }) => {
  const [stats, setStats] = useState<StatsData | null>(null);

  useEffect(() => {
    if (!worker) return;

    const handleMessage = ({ data: { type, payload } }: MessageEvent) => {
      if (type === WorkerPayloadTypes.WorkerStats) {
        setStats(payload);
      }
    };

    worker.addEventListener("message", handleMessage);

    return () => {
      worker.removeEventListener("message", handleMessage);
    };
  }, [worker]);

  if (!stats) return null;

  return (
    <div className={styles.stats}>
      <p>FPS: {stats.fps}</p>
      <p>MS: {stats.ms.toFixed(2)}</p>
      <p>Calls: {stats.calls}</p>
      <p>Triangles: {stats.triangles.toLocaleString()}</p>
      <p>Points: {stats.points}</p>
      <p>Lines: {stats.lines}</p>
      <p>Geometries: {stats.geometries}</p>
      <p>Textures: {stats.textures}</p>
      <p>Programs: {stats.programs}</p>
    </div>
  );
};
